import React from "react";
import { Typography, Row, Col, Avatar, Button, Space } from "antd";
import { 
  HeartOutlined, 
  ShoppingOutlined, 
  UserOutlined,
  DownOutlined,
  GiftOutlined
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const Domoelec = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#ffffff' }}>
   

      {/* Main Content */}
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '60px 24px' }}>
        
        {/* Title Section */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <Title level={1} style={{ 
            fontSize: '48px', 
            fontWeight: 700, 
            color: '#000',
            marginBottom: '20px'
          }}>
            À Propos de nous
          </Title>
        
      </div>

        {/* Two Column Layout */}
        <Row gutter={[60, 60]} align="top">
          {/* Left Column - Text Content */}
          <Col xs={24} lg={12}>
            <div>
      
              
              <Paragraph style={{ 
                fontSize: '18px', 
                lineHeight: 1.8, 
                color: '#333',
                marginBottom: '30px'
              }}>
                <strong>DOMOELEC</strong> est votre partenaire de confiance depuis plus de 20 ans dans le domaine du courant faible. 
                Nous nous spécialisons dans l'installation, la maintenance et l'innovation de systèmes électriques 
                pour les professionnels et les collectivités, en garantissant <strong>qualité, sécurité et performance </strong> 
                 dans chaque projet que nous réalisons.
              </Paragraph>

              <div style={{ 
                background: '#f8f9fa',
                padding: '30px',
                borderRadius: '8px',
                borderLeft: '4px solid #1890ff',
                marginBottom: '30px'
              }}>
                <Paragraph style={{ 
                  fontSize: '18px', 
                  lineHeight: 1.8, 
                  color: '#333',
                  fontStyle: 'italic',
                  margin: 0
                }}>
                  "Après plus de 20 ans d'expérience dans le courant faible, nous avons développé une expertise 
                  unique qui nous permet de proposer des solutions sur mesure. Notre mission ? 
                  Révolutionner l'approche des installations électriques : plus intelligentes, plus durables 
                  et toujours conformes aux normes de sécurité les plus strictes."
                </Paragraph>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                <Avatar 
                  size={50} 
                  style={{ marginRight: '15px' }}
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face"
                />
                <div>
                  <Text style={{ fontSize: '16px', fontWeight: 600, color: '#000' }}>
                    TARIK ELBOURZQUI
                  </Text>
                  <br />
                  <Text style={{ fontSize: '14px', color: '#666' }}>
                    Fondateur Domoelec
                  </Text>
                </div>
              </div>
            </div>
          </Col>

          {/* Right Column - Image */}
          <Col xs={24} lg={12}>
            <div style={{ 
              background: '#f0f0f0',
              height: '500px',
              borderRadius: '8px',
              backgroundImage: 'url("/images/domoelec.webp")',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative'
            }}>
              {/* Overlay for better text readability if needed */}
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(transparent, rgba(0,0,0,0.3))',
                height: '100px'
              }} />
              </div>
          </Col>
        </Row>
      </div>

  
    </div>
  );
};

export default Domoelec;
